import { observer } from 'mobx-react-lite'
import NextButton from './components/NextButton/NextButton'
import { useStore } from '../../module/rootStore'
import styled from './ButtonFooter.module.scss'
import { Player } from '@lottiefiles/react-lottie-player'
import loader from '../../assets/loader.json'
import { useMemo } from 'react'
import ErrorBanner from './components/ErrorBanner/ErrorBanner'
import { substituteValue } from '../../lib/substitute/substituteValue'
import BankSslBanner from '../BankSsl/BankSslBanner'
import BankButton from './components/BankButton/BankButton'

const ButtonFooter = ({
  isBankAccount = false
}) => {
  const {
    nextCurrentStep,
    redirectButtonHandler,
    stepsSetting,
    currentStep,
    isApiLoading,
    stepsInputs,
    invalidInputs,
    inputsData,
    values,
    replacements,
  } = useStore().StepsStore
  console.log({ ...invalidInputs })
  const hasErrors = useMemo(() => {
    const newInvalidInputs = Object.keys(invalidInputs).filter(key => {
      //@ts-ignore
      return invalidInputs[key] !== false
    })
    return Boolean(newInvalidInputs.length)
  }, [invalidInputs])
  // const [hasErrors, errors] = useMemo(() => {
  //   const displayedErrors = stepsInputs.reduce((accumulator, step) => {
  //     const stepErrors = step
  //       .filter((name) => invalidInputs.hasOwnProperty(name))
  //       .map((name) => {
  //         switch (name) {
  //           case 'bank_account':
  //             return substituteValue(
  //               inputsData[name]?.label ?? '',
  //               values,
  //               replacements
  //             )
  //           default:
  //             return substituteValue(
  //               inputsData[name]?.title?.text ??
  //               inputsData[name]?.label ??
  //               name,
  //               values,
  //               replacements
  //             )
  //         }
  //       })
  //     return [...accumulator, ...stepErrors]
  //   }, [])

  //   if (invalidInputs['error']) {
  //     displayedErrors.push(invalidInputs['error'])
  //   }
  //   return [Boolean(Object.keys(invalidInputs).length), displayedErrors]
  // }, [invalidInputs])

  const isLastStep = useMemo(
    () => currentStep + 1 === stepsSetting.length,
    [currentStep]
  )

  const doNothing = () => { }

  return (
    <div className={styled.button_footer}>
      <div className={styled.container}>
        {!isLastStep && !isBankAccount && (
          <>
            {isApiLoading && (
              <NextButton onClick={doNothing}>
                <Player
                  autoplay
                  loop
                  src={loader}
                  style={{ height: '90px', width: '90px' }}
                />
              </NextButton>
            )}
            {!isApiLoading && (
              <>
                <NextButton onClick={nextCurrentStep}>Siguiente</NextButton>
                <div className={styled.dashed} />
                <div className={styled.footer_title}>
                  {stepsSetting[currentStep + 1]?.title}
                </div>
              </>
            )}
          </>
        )}
        {isLastStep && (
          <>
            {
              isApiLoading &&
              <>
                <NextButton onClick={doNothing}>
                  <Player
                    autoplay
                    loop
                    src={loader}
                    style={{ height: '90px', width: '90px' }}
                  />
                </NextButton>
                <div className={styled.dashed} />
                <div className={styled.footer_title}>Ingreso de dinero</div>
              </>
            }
            {
              !isApiLoading &&
              <>
                <NextButton onClick={redirectButtonHandler}>Finalizar</NextButton>
                <div className={styled.dashed} />
                <div className={styled.footer_title}>Ingreso de dinero</div>
              </>
            }

          </>
        )}
        {
          isBankAccount && (
            <>
              <BankButton onClick={nextCurrentStep} >
                Continuar
              </BankButton>
              <div className={styled.dashed} />
              <div className={styled.footer_title}>
                {stepsSetting[currentStep + 1]?.title}
              </div>
            </>
          )
        }
      </div>
      {
        isBankAccount && (
          <BankSslBanner />
        )
      }
      {hasErrors && <ErrorBanner errors={[]} />}
    </div>
  )
}

export default observer(ButtonFooter)
